import { capFirstChar } from '../utilities';
//Types
import type { DeviceStatusG2 } from 'src/types/DeviceStatusG2';
import type {
	ComponentsGroupInterface,
	VirtualComponentConfig,
	VirtualComponentInterface,
	VirtualComponentInterfaceData,
} from 'src/types/VirtualComponents';

export const bthomeObjectTitle = (config: VirtualComponentConfig) => {
	if (config?.obj_id) {
		const bthomeObj = bthomeObjectInfos.find((i) => i.id == config?.obj_id);
		return bthomeObj?.name ? capFirstChar(bthomeObj.name.replace(/_/g, ' ')) : null;
	}
	return null;
};

export const bthomeObjectInfos = [
	{ id: 1, name: 'battery', type: 'sensor', unit: '%' },
	{ id: 2, name: 'temperature', type: 'sensor', unit: '°C' },
	{ id: 3, name: 'humidity', type: 'sensor', unit: '%' },
	{ id: 4, name: 'pressure', type: 'sensor', unit: 'hPa' },
	{ id: 5, name: 'illuminance', type: 'sensor', unit: 'lx' },
	{ id: 6, name: 'mass_kg', type: 'sensor', unit: 'kg' },
	{ id: 7, name: 'mass_lb', type: 'sensor', unit: 'lb' },
	{ id: 8, name: 'dewpoint', type: 'sensor', unit: '°C' },
	{ id: 9, name: 'count', type: 'sensor', unit: '' },
	{ id: 10, name: 'energy', type: 'sensor', unit: 'kWh' },
	{ id: 11, name: 'power', type: 'sensor', unit: 'W' },
	{ id: 12, name: 'voltage', type: 'sensor', unit: 'V' },
	{ id: 13, name: 'pm2.5', type: 'sensor', unit: 'ug/m3' },
	{ id: 14, name: 'pm10', type: 'sensor', unit: 'ug/m3' },
	{ id: 15, name: 'generic_boolean', type: 'binary_sensor', unit: '' },
	{ id: 16, name: 'power_status', type: 'binary_sensor', unit: '' },
	{ id: 17, name: 'opening', type: 'binary_sensor', unit: '' },
	{ id: 18, name: 'co2', type: 'sensor', unit: 'ppm' },
	{ id: 19, name: 'tvoc', type: 'sensor', unit: 'ug/m3' },
	{ id: 20, name: 'moisture', type: 'sensor', unit: '%' },
	{ id: 21, name: 'battery_status', type: 'binary_sensor', unit: '' },
	{ id: 22, name: 'battery_charging', type: 'binary_sensor', unit: '' },
	{ id: 23, name: 'carbon_monoxide', type: 'binary_sensor', unit: '' },
	{ id: 24, name: 'cold', type: 'binary_sensor', unit: '' },
	{ id: 25, name: 'connectivity', type: 'binary_sensor', unit: '' },
	{ id: 26, name: 'door', type: 'binary_sensor', unit: '' },
	{ id: 27, name: 'garage_door', type: 'binary_sensor', unit: '' },
	{ id: 28, name: 'gas', type: 'binary_sensor', unit: '' },
	{ id: 29, name: 'heat', type: 'binary_sensor', unit: '' },
	{ id: 30, name: 'light', type: 'binary_sensor', unit: '' },
	{ id: 31, name: 'lock', type: 'binary_sensor', unit: '' },
	{ id: 32, name: 'moisture', type: 'binary_sensor', unit: '' },
	{ id: 33, name: 'motion', type: 'binary_sensor', unit: '' },
	{ id: 34, name: 'moving', type: 'binary_sensor', unit: '' },
	{ id: 35, name: 'occupancy', type: 'binary_sensor', unit: '' },
	{ id: 36, name: 'plug', type: 'binary_sensor', unit: '' },
	{ id: 37, name: 'presence', type: 'binary_sensor', unit: '' },
	{ id: 38, name: 'problem', type: 'binary_sensor', unit: '' },
	{ id: 39, name: 'running', type: 'binary_sensor', unit: '' },
	{ id: 40, name: 'safety', type: 'binary_sensor', unit: '' },
	{ id: 41, name: 'smoke', type: 'binary_sensor', unit: '' },
	{ id: 42, name: 'sound', type: 'binary_sensor', unit: '' },
	{ id: 43, name: 'tamper', type: 'binary_sensor', unit: '' },
	{ id: 44, name: 'vibration', type: 'binary_sensor', unit: '' },
	{ id: 45, name: 'window', type: 'binary_sensor', unit: '' },
	{ id: 46, name: 'humidity', type: 'sensor', unit: '%' },
	{ id: 47, name: 'moisture', type: 'sensor', unit: '%' },
	{ id: 58, name: 'button', type: 'button', unit: '' },
	{ id: 60, name: 'dimmer', type: 'dimmer', unit: '' },
	{ id: 61, name: 'count', type: 'sensor', unit: '' },
	{ id: 62, name: 'count', type: 'sensor', unit: '' },
	{ id: 63, name: 'rotation', type: 'sensor', unit: '°' },
	{ id: 64, name: 'distance_mm', type: 'sensor', unit: 'mm' },
	{ id: 65, name: 'distance_m', type: 'sensor', unit: 'm' },
	{ id: 66, name: 'duration', type: 'sensor', unit: 's' },
	{ id: 67, name: 'current', type: 'sensor', unit: 'A' },
	{ id: 68, name: 'speed', type: 'sensor', unit: 'm/s' },
	{ id: 69, name: 'temperature', type: 'sensor', unit: '°C' },
	{ id: 70, name: 'uv_index', type: 'sensor', unit: 'UV' },
	{ id: 71, name: 'volume', type: 'sensor', unit: 'L' },
	{ id: 72, name: 'volume', type: 'sensor', unit: 'mL' },
	{ id: 73, name: 'volume_flow_rate', type: 'sensor', unit: 'm3/hr' },
	{ id: 74, name: 'voltage', type: 'sensor', unit: 'V' },
	{ id: 75, name: 'gas', type: 'sensor', unit: 'm3' },
	{ id: 76, name: 'gas', type: 'sensor', unit: 'm3' },
	{ id: 77, name: 'energy', type: 'sensor', unit: 'kWh' },
	{ id: 78, name: 'volume', type: 'sensor', unit: 'L' },
	{ id: 79, name: 'water', type: 'sensor', unit: 'L' },
	{ id: 80, name: 'timestamp', type: 'sensor', unit: '' },
	{ id: 81, name: 'acceleration', type: 'sensor', unit: 'm/s²' },
	{ id: 82, name: 'gyroscope', type: 'sensor', unit: '°/s' },
	{ id: 86, name: 'conductivity', type: 'sensor', unit: 'µS/cm' },
	{ id: 88, name: 'temperature', type: 'sensor', unit: '°C' },
	{ id: 89, name: 'count', type: 'sensor', unit: '' },
	{ id: 90, name: 'count', type: 'sensor', unit: '' },
	{ id: 91, name: 'count', type: 'sensor', unit: '' },
	{ id: 92, name: 'power', type: 'sensor', unit: 'W' },
	{ id: 93, name: 'current', type: 'sensor', unit: 'A' },
	{ id: 94, name: 'direction', type: 'sensor', unit: '°' },
	{ id: 95, name: 'precipitation', type: 'sensor', unit: 'mm' },
	{ id: 96, name: 'channel', type: 'number', unit: '' },
];

type BthomeDeviceModel = {
	id: number;
	hex: string;
	type: string;
	name: string;
	deviceType: string;
	buttons: number;
};

/*
* Validate the BLE device model ID using the Android Debug App or the official documentation:
https://shelly-api-docs.shelly.cloud/docs-ble/common/#manufacturer-data-in-scan-response
*/
export const bthomeDeviceToModel: BthomeDeviceModel[] = [
	{
		id: 0,
		hex: '0x0000',
		type: 'unknown',
		name: 'Unknown',
		deviceType: 'unknown',
		buttons: 1,
	},
	{
		id: 1,
		hex: '0x0001',
		type: 'SBBT-002C',
		name: 'Shelly BLU Button1',
		deviceType: 'button',
		buttons: 1,
	},
	{
		id: 2,
		hex: '0x0002',
		type: 'SBDW-002C',
		name: 'Shelly BLU DoorWindow',
		deviceType: 'sensor',
		buttons: 1,
	},
	{
		id: 3,
		hex: '0x0003',
		type: 'SBHT-003C',
		name: 'Shelly BLU HT',
		deviceType: 'sensor',
		buttons: 1,
	},
	{
		id: 4,
		hex: '0x0004',
		type: 'SBDS-002A',
		name: 'Shelly BLU Distance',
		deviceType: 'sensor',
		buttons: 1,
	},
	{
		id: 5,
		hex: '0x0005',
		type: 'SBMO-003Z',
		name: 'Shelly BLU Motion',
		deviceType: 'sensor',
		buttons: 1,
	},
	{
		id: 6,
		hex: '0x0006',
		type: 'SBBT-004CEU',
		name: 'Shelly BLU Wall Switch 4',
		deviceType: 'button',
		buttons: 4,
	},
	{
		id: 7,
		hex: '0x0007',
		type: 'SBBT-004CUS',
		name: 'Shelly BLU RC Button 4',
		deviceType: 'button',
		buttons: 4,
	},
	{
		id: 13,
		hex: '0x000D',
		type: 'SBBT-004C',
		name: 'Shelly BLU Button 4',
		deviceType: 'button',
		buttons: 4,
	},
	{
		id: 8,
		hex: '0x0008',
		type: 'SBTR-001AEU',
		name: 'Shelly BLU TRV',
		deviceType: 'thermostat',
		buttons: 0,
	},
	{
		id: 9,
		hex: '0x0009',
		type: 'SBRC-005B',
		name: 'Shelly BLU Remote Control ZB',
		deviceType: 'remote_control',
		buttons: 2,
	},
	{
		id: 10,
		hex: '0x000A',
		type: 'SBDI-003E',
		name: 'Shelly BLU Distance',
		deviceType: 'sensor',
		buttons: 1,
	},
	{
		id: 11,
		hex: '0x000B',
		type: 'SBWS-90CM',
		name: 'Shelly Weather Station',
		deviceType: 'sensor',
		buttons: 1,
	},
	{
		id: 12,
		hex: '0x000C',
		type: 'SBHT-103C',
		name: 'Shelly BLU HT Display ZB',
		deviceType: 'sensor',
		buttons: 1,
	},
	{
		id: 14,
		hex: '0x000E',
		type: 'SMSN-0031ZL',
		name: 'Shelly Smoke LTE',
		deviceType: 'sensor',
		buttons: 1,
	},
	{
		id: 17,
		hex: '0x0011',
		type: 'SBHT-203C',
		name: 'Shelly BLU HT ZB',
		deviceType: 'sensor',
		buttons: 1,
	},
	{
		id: 19,
		hex: '0x0013',
		type: 'SBMO-103Z',
		name: 'Shelly BLU Motion ZB',
		deviceType: 'sensor',
		buttons: 1,
	},
	{
		id: 20,
		hex: '0x0014',
		type: 'SBDW-103C',
		name: 'Shelly BLU Door Window ZB',
		deviceType: 'sensor',
		buttons: 1,
	},
	{
		id: 21,
		hex: '0x0015',
		type: 'SBBT-104CEU',
		name: 'Shelly BLU Wall Switch 4 ZB',
		deviceType: 'button',
		buttons: 4,
	},
	{
		id: 22,
		hex: '0x0016',
		type: 'SBBT-104CUS',
		name: 'Shelly BLU RC Button 4 ZB',
		deviceType: 'button',
		buttons: 4,
	},
	{
		id: 23,
		hex: '0x0017',
		type: 'SBBT-102C',
		name: 'Shelly BLU Button Tough 1 ZB',
		deviceType: 'button',
		buttons: 1,
	},
	{
		id: 24,
		hex: '0x0018',
		type: 'SBRK-002C',
		name: 'Shelly BLU Rotary Knob ZB',
		deviceType: 'remote_control',
		buttons: 1,
	},
	{
		id: 25,
		hex: '0x0019',
		type: 'SBMS-001A',
		name: 'Shelly BLU Soil',
		deviceType: 'sensor',
		buttons: 1,
	},
	{
		id: 32,
		hex: '0x0020',
		type: 'SBDW-203C',
		name: 'Shelly BLU Door Window Outdoor ZB',
		deviceType: 'sensor',
		buttons: 1,
	},
	{
		id: 33,
		hex: '0x0021',
		type: 'SBDW-302C',
		name: 'Shelly BLU Door Window Mini ZB',
		deviceType: 'sensor',
		buttons: 1,
	},
	{
		id: 40,
		hex: '0x0028',
		type: 'SBBT-102CEU',
		name: 'Shelly BLU Wall Switch 2 ZB',
		deviceType: 'button',
		buttons: 2,
	},
	{
		id: 49,
		hex: '0x0031',
		type: 'SBSN-001B',
		name: 'Shelly BLU Liquid Level Sensor ZB',
		deviceType: 'sensor',
		buttons: 1,
	},
];

export const getBthomeButtonStatus = (
	deviceStatus: DeviceStatusG2,
	config: VirtualComponentConfig,
	component: string,
	interface_data = [],
) => {
	if (/^bthomedevice:/.test(component)) {
		const bthomedeviceModel = getBthomeDeviceModel(deviceStatus?.[component]);
		if (bthomedeviceModel) {
			const mainLabel = bthomedeviceModel.deviceType == 'button';
			interface_data.push({
				...getBthomeButtonValue(deviceStatus, config, -1),
				name: `bthomebutton:0`,
				id: 0,
				vcType: bthomedeviceModel.deviceType,
				vcView: mainLabel ? bthomedeviceModel.deviceType : 'label',
				hideLabel: true,
				component,
				mainLabel,
			});
		}
	}
	return interface_data;
};

export const getBthomeButtonValue = (
	deviceStatus: DeviceStatusG2,
	config: VirtualComponentConfig,
	btnIndex: number,
): VirtualComponentInterfaceData => {
	const event = deviceStatus?.[`v_meve:${config?.id}`];
	return {
		event: (btnIndex == -1 || event?.idx == btnIndex) && event?.ev,
		idx: event?.idx,
		value: null,
		unit: '',
		icon: '',
		label: '',
		isBleButton: true,
	};
};

export const getBthomedeviceComponents = (
	group: ComponentsGroupInterface,
	item: ComponentsGroupInterface,
) => {
	if (/^bthomedevice:/.test(item?.key)) {
		const bthomedeviceModel = getBthomeDeviceModel(item.status);
		if (
			bthomedeviceModel &&
			group.items.find((i) => i?.config?.obj_id == 58 && i?.config?.addr == item?.config?.addr) ==
				null
		) {
			const buttons = bthomedeviceModel.buttons;
			for (let i = 0; i < buttons; ++i) {
				group.items.push({
					id: item.id,
					idx: i,
					buttons,
					key: `bthomebutton:${i}`,
					config: item.config,
					status: item.status,
				});
			}
		}
	}
};

export const getBthomeDeviceModel = (componentStatus: VirtualComponentInterface['status']) => {
	return bthomeDeviceToModel.find((i) => i.id == componentStatus?._attrs?.model_id && i.buttons);
};
